import { ActionType } from "./types";
import * as actionTypes from "../actions";
import moment from "moment";
import { TIMEZONE } from "../utils/constants";

type ApiUsageTypes = {
  apiUsage: any,
  apiUsageData: any,
  ApiUsageQueryData: {};
}

const initialState: ApiUsageTypes = {
  apiUsage: {},
  apiUsageData: [],
  ApiUsageQueryData: {
    startTime: moment().clone().startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
    endTime: moment().format('YYYY-MM-DDTHH:mm:ss'),
    searchText: "",    // optional parameter, we can pass this to filter more specific data
    providerName: null, // optional parameter, we can pass this to filter more specific data
    partnerName: null, // optional parameter, we can pass this to filter more specific data
    type: null,  // optional parameter, we can pass this to filter more specific data
    subType: null, // optional parameter, we can pass this to filter more specific data
    status: null,
    timeZone: TIMEZONE,
    marketName: null
  }
};

const apiUsage = (state = initialState, action: ActionType) => {
  switch (action.type) {
    case actionTypes.GET_API_USAGE_DATA: {    
      const {queryString, forceReset} = action.payload  
      return {
        ...state,
        apiUsage: action.payload?.response,
        apiUsageData: action.payload?.response?.analyticsResponse[0]?.analyticsData,
        ApiUsageQueryData: {...(forceReset ? {} : state.ApiUsageQueryData), ...queryString}
      };
    }
    case actionTypes.SET_API_USAGE_QUERY_DATA: {      
      const queryString = action.payload
      return {
        ...state,
        ApiUsageQueryData: queryString
      };
    }
    default: {
      return state;
    }
  }
};

export default apiUsage;
